/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const video_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#video_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M.75 9.873v10.5c0 .817.683 1.5 1.5 1.5H12m11.25-9.75v-2.25m-15-9-1.5 6m10.5-6-1.5 6m7.5 0H.75v-4.5c0-.817.683-1.5 1.5-1.5h19.5c.817 0 1.5.683 1.5 1.5v4.5Zm-.364 11.234-6.042-3.625c-.48-.288-1.136.07-1.136.643v7.25c0 .573.656.931 1.136.643l6.042-3.625c.477-.287.467-1.006 0-1.286Z"
      />
    </g>
    <defs>
      <clipPath id="video_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default video_medium
